export const FORM_VIEWED_EVENT = 'form_viewed';
export const FORM_FIELD_INTERACTED = 'form_field_interacted';
